<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-组织-修改
    -->
    <el-dialog
    title="修改组织"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">

        <el-form-item label="组织名称" prop="name"><el-input v-model="form.name" placeholder="请输入组织名称" class="max-w460"></el-input></el-form-item>


      <el-form-item label="默认管理员" prop="default_admin"><el-input v-model="form.default_admin" placeholder="请输入默认管理员" class="max-w460"></el-input></el-form-item>
<el-form-item label="组织类型" prop="organization_type"><el-input v-model="form.organization_type" placeholder="请输入组织类型" class="max-w460"></el-input></el-form-item>
      <el-form-item label="上级组织" prop="parent_organization">
        <el-select v-model="form.parent_organization" placeholder="请选择上级组织" clearable filterable style="width: 460px;">
          <el-option v-for="item in organizationList" :key="item.ma_organization_id" :label="item.name" :value="item.ma_organization_id"></el-option>
        </el-select>
      </el-form-item>
<el-form-item label="行政区域" prop="administrative_region">
        <div style="display: flex;">
          <el-select @change="provinceChange" v-model="form.province_name" filterable placeholder="请选择省份" style="width: 140px; margin-right: 10px;">
            <el-option v-for="item in province_options" :key="item.id" :label="item.name" :value="item"></el-option>
          </el-select>
          <el-select @change="cityChange" v-model="form.city_name" filterable placeholder="请选择城市" :disabled="lock_city" style="width: 140px; margin-right: 10px;">
            <el-option v-for="item in city_options" :key="item.id" :label="item.name" :value="item"></el-option>
          </el-select>
          <el-select @change="regionChange" v-model="form.region_name" filterable placeholder="请选择区域" :disabled="lock_region" style="width: 140px;">
            <el-option v-for="item in region_options" :key="item.id" :label="item.name" :value="item"></el-option>
          </el-select>
        </div>
      </el-form-item> 

      <el-form-item label="排序" prop="name"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>
       
    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
      </div>
</el-dialog>
  
</template>

<script>
import Ma_organizationApi from '@/api/ma_organization.js';
import UserApi from '@/api/user.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
export default {
  components: {
     /*图片上传*/
     Upload: Upload,
     draggable,
     Uediter
  },
  data() {
    return {
          /*是否上传图片*/
          isupload: false,
      isImg: false,  
          /*富文本配置*/
          ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        // categorya:{
        //   name:""
        // },
        image:[],
        sort:50,
        intro:"",
        bannar:[],
        province_name: '',
        city_name: '',
        region_name: '',
        province_id: 0,
        city_id: 0,
        region_id: 0,
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入组织名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      iscategorya:false,
      excludeIds:[],
      isProductUpload:false,
         code:"album",
         lock_city: true,
         lock_region: true,
         province_options: {},
         city_options: {},
         region_options: {},
         organizationList: []
      };
    },
  created() {
    this.dialogVisible = this.open_add;
    this.getAddressList();
    this.getOrganizationList();
    this.getDetail();
  },
  props: ["open_add","ma_organization_id"],
  methods: {

    chooseCategory(){
      this.iscategorya = true;
    },

    /*获取组织列表*/
    getOrganizationList() {
      let self = this;
      Ma_organizationApi.list({}, true)
        .then(data => {
          self.organizationList = data.data.list.data;
        })
        .catch(error => {});
    },

     /*上传*/
     openUpload(e) {
      this.isupload = true;
    },

     /*获取图片*/
     returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
          this.form.image = e[0].file_path;
          this.isImg = true;
        
      }
      this.isupload = false;
    },
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      Ma_organizationApi.detail({ma_organization_id: self.ma_organization_id},true).then(res => {
          self.form = res.data;
          self.ueditor.text = self.form.intro;
          self.isImg = true
          self.loading = false;
          if(!self.form.bannar){
            self.form.bannar = [];
          }
          if(!self.form.image){
            self.form.image = [];
          }
          if(self.form.province_id){
            self.cityList(self.form.province_id);
            self.lock_city = false;
          }
          if(self.form.city_id){
            self.regionList(self.form.city_id);
            self.lock_region = false;
          }
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;

      form.ma_organization_id = self.ma_organization_id;
      //form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Ma_organizationApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

  
    /*上传业务附件*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.image.concat(e);
        this.$set(this.form, "image", imgs);
      }
      }else{
        if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        console.log(typeof imgExpt);
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        let imgs = this.form.bannar.concat(e);
        this.$set(this.form, "bannar", imgs);
      }
      }
      
      this.isProductUpload = false;
    },

    /*删除业务附件*/
    deleteImg(index,code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
      
    },

    /*省份获取*/
    getAddressList() {
      let self = this;
      UserApi.provinceList('', true)
        .then(data => {
          self.province_options = data.data.list;
        })
        .catch(error => {});
    },

    /*市列表*/
    cityList(id) {
      let self = this;
      let Params = {};
      Params.province_id = id;
      UserApi.city_list(Params, true)
        .then(data => {
          self.city_options = data.data.list;
        })
        .catch(error => {});
    },

    /*区列表*/
    regionList(id) {
      let self = this;
      let Params = {};
      Params.region_id = id;
      UserApi.region_list(Params, true)
        .then(data => {
          self.region_options = data.data.list;
        })
        .catch(error => {});
    },

    /*选择省*/
    provinceChange(e) {
      let self = this;
      self.form.province_id = e.id;
      self.form.province_name = e.name;
      self.form.city_id = 0;
      self.form.city_name = '';
      self.form.region_id = 0;
      self.form.region_name = '';
      self.lock_city = false;
      self.lock_region = true;
      self.cityList(e.id);
    },

    /*选择市*/
    cityChange(e) {
      let self = this;
      self.form.city_id = e.id;
      self.form.city_name = e.name;
      self.form.region_id = 0;
      self.form.region_name = '';
      self.lock_region = false;
      self.regionList(e.id);
    },

    /*选择区*/
    regionChange(e) {
      let self = this;
      self.form.region_id = e.id;
      self.form.region_name = e.name;
    },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}



.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_organization/index/part/edit.vue